<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'common.pointStrategies'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form
      [id]="formId"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
    >
      <section>
        <fieldset>
          <legend>
            {{ "common.pointStrategiesDetail" | translate }}
          </legend>

          <div class="tw-flex-center">
            <!-- editable -->
            <div class="editable-table">
              <!-- cols -->
              <div class="cols">
                <!-- empty col -->
                <div
                  class="col__item dark:!tw-bg-dark-200 dark:tw-text-gray-200 tw-flex-center tw-font-medium tw-text-[13px] tw-bg-gradient-to-t tw-from-gray-200 tw-to-white dark:tw-from-dark-100/80 dark:tw-to-dark-200"
                  style="width: 211px"
                >
                  {{ "common.strategyTitle" | translate }}
                </div>

                @for (item of
                allPossibleIndices.slice().reverse(); track
                $index; let last = $last) {
                <ng-container>
                  <div
                    class="col__item dark:!tw-bg-dark-200 dark:tw-text-gray-200 tw-bg-gradient-to-t tw-from-gray-200 tw-to-white dark:tw-from-dark-100/80 dark:tw-to-dark-200"
                    [style.width]="last ? '181px' : ''"
                  >
                    <!-- title -->
                    <div
                      class="col__title dark:tw-text-gray-200"
                      [class]="item?.key"
                    >
                      {{ item?.value }}
                    </div>
                  </div>
                </ng-container>
                }
              </div>

              <!-- rows -->
              <div class="rows">
                <ng-container
                  *ngFor="
                    let range of pointPerIndexModel;
                    let rangeIndex = index
                  "
                >
                  <div
                    class="row__flex"
                    [class.selected]="selectedRows.has(rangeIndex)"
                    (click)="
                      innerWidth > 768 ? selectRow(rangeIndex, $event) : null
                    "
                  >
                    <!-- strategies names -->
                    <div class="row__title selectable-cell tw-px-1 tw-relative">
                      <input
                        (click)="selectRow(rangeIndex, $event)"
                        [value]="selectedRows.has(rangeIndex)"
                        [checked]="selectedRows.has(rangeIndex)"
                        class="form-check-input md:tw-hidden tw-block tw-cursor-pointer tw-ml-2 !tw-w-[20px] !tw-h-[20px]"
                        type="checkbox"
                      />
                      <custom-select-search
                        appearance="fill"
                        class="tw-w-full"
                        [items]="userValueOfPurchasesList"
                        optionTitle="title"
                        optionValue="title"
                        [removable]="false"
                        [value]="range.userValueOfPurchaseStrategyTitle || '-'"
                        [isShowValidationStatusIcon]="false"
                        (itemChange)="changeStrategy($event)"
                      >
                      </custom-select-search>
                    </div>

                    <!-- input values -->
                    <ng-container
                      *ngFor="
                        let pointPerIndex of range.pointPerIndices;
                        let i = index
                      "
                    >
                      <ng-container>
                        <div class="row__value">
                          <div
                            class="tw-text-lg dir-ltr tw-w-full tw-flex-center dark:tw-text-gray-100 selectable-cell"
                          >
                            {{ pointPerIndex?.point }}
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        buttonType="button"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
